<section class="ma__breadcrumbs ma__breadcrumbs--light">
    <nav class="ma__breadcrumbs__container">
        <ol class="ma__breadcrumbs__items">
            <li class="ma__breadcrumbs__item" aria-label="breadcrumbs"><a (click)="GoToProject()" href="javascript:void(0);">{{submittal !=
                    null?"Project Name: " + (submittal.projectName==null?"":submittal.projectName) + " / EEA# " +
                    (submittal.eeaNo == null
                    ?"":submittal.eeaNo) : ""}}</a></li>
            <li class="ma__breadcrumbs__item" aria-label="breadcrumbs" aria-current="page"><a href="javascript:void(0);" aria-current="page">{{documentType}}</a></li>
        </ol>
    </nav>
</section>
<div class="pre-content">
    <div class="ma__page-header">
        <div class="ma__page-header__content">
            <h2 class="ma__comp-heading" id="ViewSubmittal">
                View a Submittal
            </h2>
        </div>
    </div>
</div>
<form [formGroup]="form" aria-labelledby="ViewSubmittal">
    <div class="main-content main-content--two">
        <div class="page-content-admin">
            <ul class="nav nav-tabs" id="subTabs" role="tablist">
                <a aria-controls="submittalInfo-tab" [attr.aria-selected]="tabIndex[0]" [ngClass]="{'nav-link': true, 'active show': tabIndex[0] }" (click)="onBackClick()" href="javascript:void(0);" id="submittalInfo-tab" class="nav-item" role="tab">
                    Submittal Information</a>
                <a aria-controls="attachments-tab" [attr.aria-selected]="tabIndex[1]" [ngClass]="{'nav-link': true, 'active show': tabIndex[1] }" (click)="onNextClick()" href="javascript:void(0);" id="attachments-tab" class="nav-item" role="tab">
                    Attachments</a>
            </ul>
            <div class="tab-content" id="subtabs">
                <div aria-labelledby="submittalInfo-tab" class="tab-pane fade in show active" [ngClass]="{'active show': tabIndex[0] }" id="submittalInfo" role="tabpanel">
                    <div class="panel panel-primary">
                        <div class="panel-body">
                            <h3 class="ma__comp-heading">Submittal Information</h3>
                            <div class="row">
                                <div class="col-md-4 col-xs-4">
                                    <label for="withdrawn" class="ma__label ma__label" style="margin-top: 0px;" id="withdrawnLabel">Withdrawn:</label>
                                </div>
                                <div class="col-md-8 col-xs-8">
                                    <ui-switch id="withdrawn" formControlName="withdrawn" name="withdrawn" uncheckedLabel="NO" checkedLabel="YES" role="switch" aria-labelledby="withdrawnLabel" [attr.aria-checked]="submittal.withdrawn">
                                    </ui-switch>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-4 col-xs-4 ma__select-box js-dropdown ma__select-box--optional">
                                    <label class="ma__select-box__label" id="submittalTypeLabel">Submittal type:</label>
                                </div>
                                <div class="col-md-8 col-xs-8 ma__select-box js-dropdown ma__select-box--optional">
                                    <p class="details" id="documentType" type="text">
                                        {{documentType!=undefined?documentType:""}}
                                    </p>
                                </div>
                                <div class="col-md-4 col-xs-4  ma__select-box js-dropdown ma__select-box--optional" *ngIf="showPublicationDate">
                                    <label class="ma__select-box__label">Monitor publication
                                        date:</label>
                                </div>
                                <div class="col-md-8 col-xs-8  ma__select-box js-dropdown ma__select-box--optional" *ngIf="showPublicationDate">
                                    <p class="details">
                                        {{ (publicationDateElement != undefined && publicationDateElement.publishDate !== '-Not Selected-') ? (publicationDateElement.publishDate | date : 'MM/dd/y'): "-Not Selected-" }}
                                    </p>
                                </div>
                                <div class="col-md-4 col-sm-4 form-group" *ngIf="showPublicationDate" [disabled]='true'>
                                    <label class="ma__label">Monitor volume, issue:</label>
                                </div>
                                <div class="col-md-8 col-sm-8 form-group" *ngIf="showPublicationDate" [disabled]='true'>
                                    <p class="details">
                                        {{ submittalVolumeIssue != undefined ? submittalVolumeIssue: "" }}
                                    </p>
                                </div>
                                <div class="col-md-4 col-xs-4" *ngIf="!hideCommentDueDate && showPublicationDate" [disabled]='true'>
                                    <label class="ma__label" id="CommentsDueDateLabel">Comments due date:</label>
                                </div>
                                <div class="col-md-8 col-xs-8" *ngIf="!hideCommentDueDate && showPublicationDate" [disabled]='true'>
                                    <p class="details">
                                        {{submittal.commentsDueDate| date :'MM/dd/yyyy'}}
                                    </p>
                                </div>
                                <div class="col-md-4 col-xs-4" *ngIf="!hideActionDate" [disabled]='true'>
                                    <label class="ma__label">Action date:</label>
                                </div>
                                <div class="col-md-8 col-xs-8" *ngIf="!hideActionDate" [disabled]='true'>
                                    <p class="details">
                                        {{submittal.actionDate| date :'MM/dd/yyyy'}}
                                    </p>
                                </div>
                                <div class="col-md-4 col-xs-4 ma__select-box js-dropdown ma__select-box--optional">
                                    <label class="ma__select-box__label">MEPA Analyst:</label>
                                </div>
                                <div class="col-md-8 col-xs-8 ma__select-box js-dropdown ma__select-box--optional">
                                    <p class="details">
                                        {{ analyst != undefined? analyst.firstName + ' ' + analyst.lastName: "-Not Selected-"}}
                                    </p>
                                </div>
                                <div class="col-md-4 col-sm-4" *ngIf="showDetermination">
                                    <label class="ma__select-box__label">Determination:</label>
                                </div>
                                <div class="col-md-8 col-sm-8" *ngIf="showDetermination">
                                    <button class="btn btn-default" disabled="true" type="button" *ngFor="let determination of determinationButtons">{{determination}}</button>
                                </div>
                                <div class="col-md-4 col-sm-4" *ngIf="!hideReviewRequest" [disabled]='true'>
                                    <label class="ma__select-box__label">Review request:</label>
                                </div>
                                <div class="col-md-8 col-sm-8" *ngIf="!hideReviewRequest" [disabled]='true'>
                                    <button class="btn btn-default" disabled="true" type="button" *ngFor="let reviewRequest of reviewRequestButtons">{{reviewRequest}}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <button class="btn btn-default" (click)="onBackClick()" type="button">
                                <span>
                                    <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="angle-left"
                                        title="back Image" class="svg-inline--fa fa-angle-left fa-w-8" role="img"
                                        xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512">
                                        <path fill="currentColor"
                                            d="M31.7 239l136-136c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9L127.9 256l96.4 96.4c9.4 9.4 9.4 24.6 0 33.9L201.7 409c-9.4 9.4-24.6 9.4-33.9 0l-136-136c-9.5-9.4-9.5-24.6-.1-34z">
                                        </path>
                                    </svg>
                                </span>&nbsp;Back
                            </button>
                            <button class="btn btn-primary float-right" type="button" (click)="onNextClick()">Next&nbsp;<span>
                                    <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="angle-right" title="Next Image"
                                        class="svg-inline--fa fa-angle-right fa-w-8" role="img"
                                        xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512">
                                        <path fill="#fff"
                                            d="M224.3 273l-136 136c-9.4 9.4-24.6 9.4-33.9 0l-22.6-22.6c-9.4-9.4-9.4-24.6 0-33.9l96.4-96.4-96.4-96.4c-9.4-9.4-9.4-24.6 0-33.9L54.3 103c9.4-9.4 24.6-9.4 33.9 0l136 136c9.5 9.4 9.5 24.6.1 34z">
                                        </path>
                                    </svg></span></button>
                        </div>
                    </div>
                </div>
                <div aria-labelledby="attachments-tab" class="tab-pane fade in" id="attachments" role="tabpanel" [ngClass]="{'active show': tabIndex[1] }">
                    <div class="panel panel-primary">
                        <div class="panel-body">
                            <h3 class="ma__comp-heading">Attachments</h3>

                            <div class="row ">
                                <fieldset class="col-lg-12 col-xs-12">
                                    <app-file-upload #submittalAttachments [submittalId]="submittalId">
                                    </app-file-upload>
                                </fieldset>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-12">
                            <button class="btn btn-default" (click)="onBackClick()" type="button"><span>
                                <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="angle-left" title="Back Image"
                                        class="svg-inline--fa fa-angle-left fa-w-8" role="img"
                                        xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512">
                                        <path fill="currentColor"
                                            d="M31.7 239l136-136c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9L127.9 256l96.4 96.4c9.4 9.4 9.4 24.6 0 33.9L201.7 409c-9.4 9.4-24.6 9.4-33.9 0l-136-136c-9.5-9.4-9.5-24.6-.1-34z">
                                        </path>
                                    </svg></span>&nbsp;Back
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</form>
<div [hidden]="!isProgress" class="loading">Loading&#8230;</div>